import script from "./SingleItemInspectionFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleItemInspectionFormView.vue?vue&type=script&setup=true&lang=js"

import "./SingleItemInspectionFormView.vue?vue&type=style&index=0&id=c539940e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c539940e"]])

export default __exports__